module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-57x57-01cba3893d84ace373f9ddd8afa67005.png";